import styled from 'styled-components';

export const WhatsNewContainer = styled.div`
  width: 100%;
`;

export const WhatsNewRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 4px;
  margin-bottom: 12px;
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #aeaeb2;
  @media (prefers-color-scheme: dark) {
    color: #8e8e93;
  }
`;

export const WhatsNewText = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #5e5e5e;
  white-space: pre-line;
  word-break: break-word;

  @media (prefers-color-scheme: dark) {
    color: #cecece;
  }
`;
